module.exports = __webpack_public_path__ + "img/sthlmgaming.763c5430.svg";